export const ACCESS_REQUESTS_STATUS_APPROVED = 'approved'
export const ACCESS_REQUESTS_STATUS_DENIED = 'denied'
export const ACCESS_REQUESTS_STATUS_PENDING = 'pending'
